<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ $t("Back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar
        :iconAction="action == 0 || action == 2 ? 0 : 1"
        :changeurl="changeurl()"
      ></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <ul class="navbar-nav">
            <h3 id="heading" ref="heading">{{ heading }}</h3>
          </ul>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card">
              <div class="card-header">
                <h4 id="content" ref="content">{{ content }}</h4>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="col-md-12" v-if="action == 2">
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <font style="color: #c8b28b"
                          ><b> {{ $t("KDP MEMBER NUMBER") }} </b></font
                        >
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        {{ kdp_member_number }}
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <font style="color: #c8b28b"
                          ><b>
                            {{ $t("FIRST NAME") }} ({{
                              $t("SAME WITH HKID/PASSPORT")
                            }})
                          </b></font
                        >
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        {{ formdata.first_name }}
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <font style="color: #c8b28b"
                          ><b>
                            {{ $t("LAST NAME") }} ({{
                              $t("SAME WITH HKID/PASSPORT")
                            }})
                          </b></font
                        >
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        {{ formdata.last_name }}
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <font style="color: #c8b28b"
                          ><b> {{ $t("EMAIL") }} </b></font
                        >
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        {{ formdata.email }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group col-md-5"
                    v-if="action == 0 || (action == 1 && show6)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("FIRST NAME")
                      }}<span style="color: red">*</span> ({{
                        $t("SAME WITH HKID/PASSPORT")
                      }})</label
                    >
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="first_name"
                      ref="first_name"
                      v-model="formdata.first_name"
                      value=""
                      :placeholder="$t('First Name')"
                    />
                  </div>
                  <div class="form-group col-md-5" v-if="action == 1 && !show6">
                    <label for="name" class="control-label"
                      >{{ $t("FIRST NAME") }} ({{
                        $t("SAME WITH HKID/PASSPORT")
                      }})</label
                    >
                    <div class="cusdiv">
                      {{ formdata.first_name }}
                    </div>
                  </div>
                  <div
                    class="form-group col-md-7"
                    v-if="action == 0 || (action == 1 && show7)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("LAST NAME")
                      }}<span style="color: red">*</span> ({{
                        $t("SAME WITH HKID/PASSPORT")
                      }})</label
                    >
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="last_name"
                      ref="last_name"
                      v-model="formdata.last_name"
                      value=""
                      :placeholder="$t('Last Name')"
                    />
                  </div>
                  <div class="form-group col-md-7" v-if="action == 1 && !show7">
                    <label for="name" class="control-label"
                      >{{ $t("LAST NAME") }} ({{
                        $t("SAME WITH HKID/PASSPORT")
                      }})</label
                    >
                    <div class="cusdiv">
                      {{ formdata.last_name }}
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div
                    class="form-group col-md-8"
                    v-if="action == 0 || (action == 1 && show8)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("EMAIL") }}<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="email"
                      ref="email"
                      v-model="formdata.email"
                      :placeholder="$t('Email')"
                      @input="check()"
                    />
                    <span
                      id="emailerror"
                      ref="emailerror"
                      style="color: red; font-size: 10px"
                    ></span>
                  </div>
                  <div class="form-group col-md-8" v-if="action == 1 && !show8">
                    <label for="name" class="control-label">{{
                      $t("EMAIL")
                    }}</label>
                    <div class="cusdiv">
                      {{ formdata.email }}
                    </div>
                  </div>
                  <div
                    class="form-group col-md-4"
                    v-if="action == 0 || (action == 1 && show1)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("GENDER")
                      }}<span style="color: red">*</span></label
                    >
                    <select
                      class="form-control"
                      name="Gender"
                      id="gender"
                      ref="gender"
                      v-model="formdata.gender"
                    >
                      <option disabled selected value style="display:none"></option>
                      <option value="1">{{ $t("Male") }}</option>
                      <option value="2">{{ $t("Female") }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4" v-if="action == 1 && !show1">
                    <label for="name" class="control-label">{{
                      $t("GENDER")
                    }}</label>
                    <div class="cusdiv">
                      {{
                        formdata.gender == 1
                          ? "Male"
                          : formdata.gender == 2
                          ? "Female"
                          : formdata.gender
                      }}
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div
                    class="form-group col-md-2"
                    v-if="action == 0 || (action == 1 && show2)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("BIRTH DAY")
                      }}</label
                    >
                    <select
                      class="form-control"
                      name="BIRTHDAYDD"
                      id="birthdaydd"
                      ref="birthdaydd"
                      v-model="formdata.birthdaydd"
                    >
                      <option disabled selected value style="display:none"></option>
                      <option v-for="n in 31" :key="n" :value="n">
                        {{ n }}
                      </option>
                    </select>
                    <span
                      id="birthdaydderror"
                      ref="birthdaydderror"
                      style="color: red; font-size: 10px"
                    ></span>
                  </div>
                  <!-- <div class="form-group col-md-2" v-if="action == 1 && !show2">
                    <label for="name" class="control-label">{{
                      $t("BIRTH DAY")
                    }}</label>
                    <div class="cusdiv">
                      {{ formdata.birthdaydd }}
                    </div>
                  </div> -->
                  <div
                    class="form-group col-md-2"
                    v-if="action == 0 || (action == 1 && show3)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("BIRTH MONTH")
                      }}<span style="color: red">*</span></label
                    >
                    <select
                      class="form-control"
                      name="BIRTHDAYMM"
                      id="birthdaymm"
                      ref="birthdaymm"
                      v-model="formdata.birthdaymm"
                    >
                      <option disabled selected value style="display:none"></option>
                      <option v-for="n in 12" :key="n" :value="n">
                        {{ n }}
                      </option>
                    </select>
                    <span
                      id="birthdaymmerror"
                      ref="birthdaymmerror"
                      style="color: red; font-size: 10px"
                    ></span>
                  </div>
                  <div class="form-group col-md-2" v-if="action == 1 && !show3">
                    <label for="name" class="control-label">{{
                      $t("BIRTH MONTH")
                    }}</label>
                    <div class="cusdiv">
                      {{ formdata.birthdaymm }}
                    </div>
                  </div>
                  <div
                    class="form-group col-md-8"
                    v-if="action == 0 || (action == 1 && show4)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("AGE RANGE")
                      }}<span style="color: red">*</span></label
                    >
                    <select
                      class="form-control"
                      name="AGE"
                      id="age"
                      ref="age"
                      v-model="formdata.age_range"
                    >
                      <option disabled selected value style="display:none"></option>
                      <option value="1">12-17</option>
                      <option value="2">18-25</option>
                      <option value="3">26-35</option>
                      <option value="4">36-45</option>
                      <option value="5">46-55</option>
                      <option value="6">56 {{ $t("above") }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-8" v-if="action == 1 && !show4">
                    <label for="name" class="control-label">{{
                      $t("AGE RANGE")
                    }}</label>
                    <div class="cusdiv">
                      {{
                        formdata.age_range == 1
                          ? "12-17"
                          : formdata.age_range == 2
                          ? "18-25"
                          : formdata.age_range == 3
                          ? "26-35"
                          : formdata.age_range == 4
                          ? "36-45"
                          : formdata.age_range == 5
                          ? "46-55"
                          : "56" + " " + $t("above")
                      }}
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div
                    class="form-group col-md-12"
                    v-if="action == 0 || (action == 1 && show5)"
                  >
                    <label for="name" class="control-label"
                      >{{ $t("LANGUAGE PREFERENCE")
                      }}<span style="color: red">*</span></label
                    >
                    <select
                      class="form-control"
                      name="language"
                      id="language"
                      ref="language"
                      v-model="formdata.language"
                    >
                      <option disabled selected value style="display:none"></option>
                      <option value="1">{{ $t("English") }}</option>
                      <option value="2">{{ $t("Simplified Chinese") }}</option>
                      <option value="3">{{ $t("Traditional Chinese") }}</option>
                    </select>
                  </div>

                  <div
                    class="form-group col-md-12"
                    v-if="action == 1 && !show5"
                  >
                    <label for="name" class="control-label">{{
                      $t("LANGUAGE PREFERENCE")
                    }}</label>
                    <div class="cusdiv">
                      {{
                        formdata.language == 1
                          ? $t("English")
                          : formdata.language == 2
                          ? $t("Simplified Chinese")
                          : formdata.language == 3
                          ? $t("Traditional Chinese")
                          : $t(formdata.language)
                      }}
                    </div>
                  </div>
                </div>
                <!-- <div class="form-row" v-if="!isWechat">
                  <div
                    class="form-group col-md-12"
                    v-if="action == 0 || action == 1 || action == 2"
                  >
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_1"
                      ref="agreement_1"
                      v-model="formdata.agreement_1"
                    />
                      <label style="margin-left: 30px; padding-top: 5px" for="agreement_1">
                          <span style="color: red">*</span>
                          <span class="text" v-html="linktext"></span>
                      </label>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="card" v-if="!isWechat">
              <div class="card-body">
                <div class="form-row" v-if="!isWechat && getPipl('PIPL_CONSENT_VERSION') === 'general'">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <p>
                      {{
                        $t(
                          "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 1">
                    <p>
                      {{
                        $t(
                           "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 2">
                    <p>
                      {{
                        $t(
                          "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                </div>

                <div class="form-row" v-if="!isWechat && getPipl('PIPL_CONSENT_VERSION') === 'minor'">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <p>
                      {{
                        $t(
                          "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 1">
                    <p>
                      {{
                        $t(
                           "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 2">
                    <p>
                      {{
                        $t(
                         "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                </div>

                <!-- first checkbox -->
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 2">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      v-model="formdata.agreement_3"
                      id="agreement_3"
                      ref="agreement_3"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_3"
                      v-html="$t('KLUB 11 and K11 LP')"
                    >
                    </label>
                  </div>
                </div>

                <!-- first checkbox -->
                <!-- <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 2">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_4"
                      ref="agreement_4"
                      v-model="formdata.agreement_4"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_4"
                       v-html="$t('KLUB 11 and K11 LP')"
                    >
                    </label>
                  </div>
                </div> -->
                <!-- second checkbox -->
                <!-- <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 2">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_5"
                      ref="agreement_5"
                      v-model="formdata.agreement_5"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_5"
                    >
                      {{
                        $t(
                          "I agree to receive news, updates and offers from the Affiliates and Marketing Partners of K11 LP/KLUB 11"
                        )
                      }}
                    </label>
                  </div>
                </div> -->
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 1">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_4"
                      ref="agreement_4"
                      v-model="formdata.agreement_4"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_4"
                      v-html="$t('K Dollar Program and MPNCL')"
                    >
                    </label>
                  </div>
                </div>
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_3"
                      ref="agreement_3"
                      v-model="formdata.agreement_3"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_3"
                      v-html="$t('KLUB 11 and K11 LP')"
                    >
                    </label>
                  </div>
                </div>
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_4"
                      ref="agreement_4"
                      v-model="formdata.agreement_4"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_4"
                      v-html="$t('K Dollar Program and MPNCL')"
                    >
                    </label>
                  </div>
                </div>
                <div class="form-row" v-if="!isWechat && getPipl('PIPL_CONSENT_VERSION') === 'general' ">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <p>
                      {{
                        $t(
                          "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 1">
                    <p>
                      {{
                        $t(
                         "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 2">
                    <p>
                      {{
                        $t(
                         "I consent to receive direct marketing from"
                        )
                      }}
                    </p>
                  </div>
                </div>

                <div class="form-row" v-if="!isWechat && getPipl('PIPL_CONSENT_VERSION') === 'minor' ">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <p>
                      {{
                        $t(
                          "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 1">
                    <p>
                      {{
                        $t(
                         "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 2">
                    <p>
                      {{
                        $t(
                          "I, as the parent/legal guardian of the minor/ data subject under the age of 18"
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_5"
                      ref="agreement_5"
                      v-model="formdata.agreement_5"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_5"
                      v-html="$t('KLUB 11 and K11 LP\'s Affiliates and/or Marketing Partners')"
                    >
                    </label>
                  </div>
                  <div class="form-group col-md-12" v-if="action == 2">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_5"
                      ref="agreement_5"
                      v-model="formdata.agreement_5"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_5"
                      v-html="$t('KLUB 11 and K11 LP\'s Affiliates and/or Marketing Partners')"
                    >
                    </label>
                  </div>
                </div>
                <div class="form-row" v-if="!isWechat">
                  <div class="form-group col-md-12" v-if="action == 0">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_6"
                      ref="agreement_6"
                      v-model="formdata.agreement_6"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_6"
                      v-html="$t('K Dollar Program and MPNCL\'s Affiliates and/or Marketing Partners')"
                    >
                    </label>
                  </div>
                   <div class="form-group col-md-12" v-if="action == 1">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="agreement_6"
                      ref="agreement_6"
                      v-model="formdata.agreement_6"
                    />
                    <label
                      style="margin-left: 30px; padding-top: 5px"
                      for="agreement_6"
                      v-html="$t('K Dollar Program and MPNCL\'s Affiliates and/or Marketing Partners')"
                    >
                    </label>
                  </div>
                </div>
                <!-- <div class="form-row" v-if="getPipl('PIPL_CONSENT_VERSION') === 'minor'">
                  <div class="form-group col-md-12" v-if="action == 0 || action == 1 || action == 2">
                    <input
                      style="left: 25px; height: 20px; width: 20px"
                      class="form-check-input cuscheckbox"
                      type="checkbox"
                      value=""
                      id="AGREE_MINOR"
                      ref="AGREE_MINOR"
                      v-model="formdata.AGREE_MINOR"
                    />
                    <label style="margin-left: 30px; padding-top: 5px" for="AGREE_MINOR">
                      <span style="color: red">*</span>
                      <span class="text">{{ $t('AGREE_MINOR')}}</span>
                    </label>
                  </div>
                </div> -->
                <!-- <div class="container" v-if="isWechat && getPipl('PIPL_CONSENT_VERSION') == 'minor'">
                    <component v-bind:is="loader" v-if="component"></component>
                </div> -->
                <div class="form-row">
                  <div class="form-group col-md-12"></div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-primary m-2"
              id="btnSubmit"
              @click.prevent="btnSubmit()"
              :disabled="disabled"
            >
              <span
                class="spinner-border spinner-border-sm"
                id="spin"
                ref="spiin"
                role="status"
                aria-hidden="true"
                v-if="spinner"
              ></span>
              <span id="loading" ref="loading">{{ loading }}</span>
            </button>
          </div>
        </section>
      </div>
      <footer class="main-footer">
        <div class="footer-left"></div>
        <div class="footer-right"></div>
      </footer>
    </div>
    <piplprompt :submit-modal="()=>{btnSubmit(true)}" v-if="showModal"></piplprompt>
  </div>
</template>
<style>
option {
  background-color: white;
  margin-bottom: 1px;
  cursor: pointer;
  padding: 0.5em;
  border-width: 0;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.cusdiv {
  font-size: 14px;
  padding: 10px 15px;
  height: 42px;
  color: black;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
import api from "@/api";
import {mapActions, mapGetters, mapMutations} from "vuex";
import helper from "@/vueHelper";

import Navbar from "@/components/Navbar.vue";
import piplprompt from "@/components/pipl-k11.vue";
import { actions } from "@/store/public";

export default {
  components: {Navbar, piplprompt},
  data() {
    return {
      errormessage: "",
      curbonus: 0,
      phone: null,
      country_code: null,
      action: 1,
      spinner: false,
      disabled: true,
      disabled2: true,
      kdp_member_number: null,
      partner_member_number: null, //vipcode
      k11accountno: null,
      iskdp: null,
      isk11: null,
      formdata: {},
      heading: "",
      content: "",
      loading: "",
      show1: true,
      show2: true,
      show3: true,
      show4: true,
      show5: true,
      show6: true,
      show7: true,
      show8: true,
      // linktext: "",
      callbackurl: null,
      session: null,
      backtohome: false,
      showModal: false,
      isKGODataReady: false
    };
  },
  watch: {
    // isSubmittable: function(val) {
    //   console.log("val", val)
    //   if (val === true) {
    //     this.disabled = true
    //   }
    //   if (this.isKGODataReady && val === false) {
    //     this.disabled = false
    //   }
    // },
    formdata: {
      handler: function (val) {
        let email = this.check();
        // let check = $(this.$refs.agreement_1).is(":checked") || this.isWechat;
        let check = this.isWeChat ? this.isWechat : true;
        if (this.formdata.age_range !== "1"){
          this.setPIPL('general');
          this.setPIPL('AGREE_MINOR_off');
        }else{
          this.setPIPL('minor');
        }

        if (this.formdata.age_range === "1" && this.formdata.AGREE_MINOR) {
            this.setPIPL('AGREE_MINOR_on');
        } else {
            this.setPIPL('AGREE_MINOR_off');
        }
        let is_minor = (this.getPipl("PIPL_CONSENT_VERSION") === 'minor' && this.getPipl("AGREE_MINOR") === '1')
            || this.getPipl("PIPL_CONSENT_VERSION") === 'general';
        if (this.isWechat === true && this.getPipl("PIPL_CONSENT_VERSION") === 'general') {
            // KGO + PIPL_CONSENT_VERSION === 'general'
            this.isKGODataReady = this.kgoFormDataCheck(email)
            this.disabled = !(this.isKGODataReady)
        } else if (this.isWechat === true && this.getPipl("PIPL_CONSENT_VERSION") === 'minor'){
            // KGO + PIPL_CONSENT_VERSION === 'minor'
            this.isKGODataReady = this.kgoFormDataCheck(email)
            this.disabled = !(this.isKGODataReady)
            //const canSubmit = this.isKGODataReady && !this.isSubmittable
        } else if (!this.isWechat && this.action == 2 && check) {
            // KKA - isWechat === false & this.action == 2
            this.disabled = false
        } else {
            console.log('normal KKA')
            console.log('check', check, 'email', email)
            // KKA - isWechat === false
            this.disabled = this.kkaIsSubmittable(check, email)
        }
        // else {
        //   if (this.action == 2 && check) {
        //     this.disabled = !is_minor; is_minor = false -> =general -> disable; minor will show button
        //   } else {
        //     this.disabled = true;
        //   }
        // }
      },
      deep: true,
    },
  },

  created() {
    //action 0 = none, 1=register kdp , 2=register k11
    this.actionSetForceBlock(false);
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.phone = window.sessionStorage.getItem("phone");
    this.country_code = window.sessionStorage.getItem("country_code");
    this.iskdp = window.sessionStorage.getItem("iskdp");
    this.isk11 = window.sessionStorage.getItem("isk11");
    this.action = window.sessionStorage.getItem("action");
    this.kdp_member_number = window.sessionStorage.getItem("kdpmembernumber");
    this.partner_member_number = window.sessionStorage.getItem("k11vipcode");
    this.k11accountno = window.sessionStorage.getItem("k11accountno");
    this.session = window.sessionStorage.getItem("session");
    let vm = this;
    let t1 = 0;
    let t2 = 0;
    this.setPIPL('reset');
    let findText = this.$t("Program Terms and Conditions");

    var re = new RegExp(findText, "g");
    let findText2 = this.$t("Personal Information Collection Statement");

    var re2 = new RegExp(findText2, "g");

    var K11poc = "https://klub-11.com/zh-hk/program-terms-and-conditions/"
    var K11Pics ="https://media.k11.com/general_assets/KLUB_11_PICS_EN.pdf"
    var KDPpoc = "https://hk.krewards.com/zh-hk/program-terms-and-conditions/"
    var KDPics ="https://hk.krewards.com/zh-hk/personal-information-collection-statement/"
    if (this.$i18n.locale == "en") {
      KDPpoc = KDPpoc.replace("zh-hk","")
      KDPics = KDPics.replace("zh-hk","")
      K11poc = KDPpoc.replace("zh-hk","")
      K11Pics = KDPics.replace("zh-hk","")
    } else if (this.$i18n.locale == "zh_CN") {
      KDPpoc = KDPpoc.replace("zh-hk","zh-cn")
      KDPics = KDPics.replace("zh-hk","zh-cn")
      K11poc = KDPpoc.replace("zh-hk","zh-cn")
      K11Pics = KDPics.replace("zh-hk","zh-cn")
    }
    // this.linktext = this.$t("I have read, understood and agrees to")
    //   .replace(
    //     this.$t("Program Terms and Conditions"),
    //       //      https://web-hk-uat.krewards.com/terms-of-use/
    //       //      https://web-hk-uat.krewards.com/zh-hk/terms-of-use/
    //       //      https://web-hk-uat.krewards.com/zh-cn/terms-of-use/
    //       `<a href="${K11poc}" target="_blank">${this.$t("Program Terms and Conditions")}</a>`
    //   )
    //   .replace(re, (match) =>
    //     ++t1 === 2
    //       ? `<a href="${KDPpoc}" target="_blank">${this.$t("Program Terms and Conditions")}</a>`
    //       : match
    //   )
    //   .replace(
    //     this.$t("Personal Information Collection Statement"),
    //       //        https://web-hk-uat.krewards.com/privacy-policy/
    //       //        https://web-hk-uat.krewards.com/zh-hk/privacy-policy/
    //       //        https://web-hk-uat.krewards.com/zh-cn/privacy-policy/
    //       `<a href="${K11Pics}" target="_blank">${this.$t("Personal Information Collection Statement")}</a>`
    //   )
    //   .replace(re2, (match) =>
    //     ++t2 === 2
    //       ? `<a href="${KDPics}" target="_blank">${this.$t("Personal Information Collection Statement")}</a>`
    //       : match
    //   );

    window.sessionStorage.clear();
    if (this.phone == null) {
        window.location.href = "./#/";
    } else {
      if (this.action == 0) {
        this.heading = this.$t(
          "Register as a KLUB 11 Membership with K Dollar Program"
        );
        this.content = this.$t(
          "Become a KLUB 11 member today to enjoy exclusive privileges"
        );
        this.loading = this.$t("Continue");
      } else if (this.action == 1) {
        this.heading = this.$t("Register K Dollar Program Account");
        this.content = this.$t(
          "Please note that your existing KLUB points will be converted as K points after binding with your registered KDP Account"
        );
        this.loading = this.$t("Register and bind account");
      } else if (this.action == 2) {
        this.heading = this.$t(
          "Register as a KLUB 11 Member and bind with K Dollar Program"
        );
        this.content =
          this.$t(
            "Any updated you would like to make form details you provided in KDP"
          ) + "?";
        this.loading = this.$t("I agree to bind");
      }

      if (this.iskdp == 1 || this.isk11 == 1) {
        helper.loading();
        api.request(
          this,
          "post",
          "/migrationhub/member/profile",
          {
            kdp_search_value: this.kdp_member_number,
            k11_search_value: this.partner_member_number,
            k11_search_type: 5,
            phone: this.phone,
            country_code: this.country_code,
            SESSION: this.session,
          },
          function (r) {
            if (r.success) {
              if (this.isk11 == 1) {
                //use k11 as reference first
                var k11 = r.data.k11;

                if (k11.givenname != null && k11.givenname != "") {
                  this.$set(this.formdata, "first_name", k11.givenname);
                } else {
                  this.$set(this.formdata, "first_name", k11.surname);
                }
                if (k11.engfamilyname != null && k11.engfamilyname != "") {
                  this.$set(this.formdata, "last_name", k11.engfamilyname);
                } else {
                  this.$set(this.formdata, "last_name", k11.chnfailyname);
                }
                this.$set(this.formdata, "email", k11.vipemail);
                if (k11.sex && k11.sex == "M") {
                  this.$set(this.formdata, "gender", 1);
                } else if (k11.sex && k11.sex == "F") {
                  this.$set(this.formdata, "gender", 2);
                } else {
                  this.$set(this.formdata, "gender", null);
                }
                if (k11.birthdaydd) {
                  this.$set(
                    this.formdata,
                    "birthdaydd",
                    parseInt(k11.birthdaydd)
                  );
                }
                if (k11.birthdaymm) {
                  this.$set(
                    this.formdata,
                    "birthdaymm",
                    parseInt(k11.birthdaymm)
                  );
                }
                if (k11.agegroup) {
                  var intRange = parseInt(k11.agegroup);
                  if (intRange == 6) {
                    intRange = 0;
                  } else {
                    intRange += 1;
                  }
                  this.$set(this.formdata, "age_range", intRange);
                }
                if (k11.language) {
                  this.$set(
                    this.formdata,
                    "language",
                    parseInt(k11.language, 10)
                  );
                }

                let check_k11vipcode = this.partner_member_number.substring(
                  0,
                  2
                );
                if (
                  this.partner_member_number.length == 16 &&
                  check_k11vipcode != "01"
                ) {
                  vm.curbonus = 0;
                } else {
                  $.ajax({
                    method: "POST",
                    contentType: "application/json",
                    url: config.serverURI + "/migrationhub/point/balance",
                    data: JSON.stringify({
                      k11_member_number: this.k11accountno,
                      kdp_member_number: null,
                      phone: this.phone,
                      country_code: this.country_code,
                      SESSION: this.session,
                    }),
                    complete: function (jdata2) {
                      if (jdata2.responseJSON.success) {
                        vm.curbonus =
                          jdata2.responseJSON.data.total_point_balance;
                      } else {
                        if (jdata2.responseJSON.errorcode == "K2013") {
                          vm.errormessage =
                            jdata2.responseJSON.msg[
                              helper.getMappingLocale(vm.$i18n.locale)
                            ];
                        } else {
                          vm.errormessage =
                            vm.$t("Something went wrong") +
                            " " +
                            jdata2.responseJSON.msg[
                              helper.getMappingLocale(vm.$i18n.locale)
                            ] +
                            "(" +
                            jdata2.responseJSON.errorcode +
                            ")";
                        }
                        $("#ReminderBox").modal("show");
                      }
                    },
                  });
                }
              } else {
                var kdp = r.data.kdp;
                this.$set(this.formdata, "first_name", kdp.name.en.first_name);

                this.$set(this.formdata, "last_name", kdp.name.en.last_name);
                this.$set(this.formdata, "email", kdp.email);

                if (kdp.gender && kdp.gender == "1") {
                  this.$set(this.formdata, "gender", 1);
                } else if (kdp.gender && kdp.gender == "2") {
                  this.$set(this.formdata, "gender", 2);
                } else {
                  this.$set(this.formdata, "gender", null);
                }
                if (kdp.date_of_birth.day) {
                  this.$set(
                    this.formdata,
                    "birthdaydd",
                    parseInt(kdp.date_of_birth.day)
                  );
                }
                if (kdp.date_of_birth.month) {
                  this.$set(
                    this.formdata,
                    "birthdaymm",
                    parseInt(kdp.date_of_birth.month)
                  );
                }
                if (kdp.age_range) {
                  this.$set(this.formdata, "age_range", kdp.age_range);
                }
                if (kdp.locale && kdp.locale == "1") {
                  this.$set(this.formdata, "language", 1);
                } else if (kdp.locale && kdp.locale == "2") {
                  this.$set(this.formdata, "language", 3);
                } else if (kdp.locale && kdp.locale == "3") {
                  this.$set(this.formdata, "language", 2);
                }
              }

              if (this.formdata.gender && this.formdata.gender != "") {
                this.show1 = false;
              }
              if (this.formdata.birthdaydd && this.formdata.birthdaydd != "") {
                this.show2 = false;
              }
              if (this.formdata.birthdaymm && this.formdata.birthdaymm != "") {
                this.show3 = false;
              }
              if (this.formdata.age_range && this.formdata.age_range != "") {
                this.show4 = false;
              }
              if (this.formdata.language && this.formdata.language != "") {
                this.show5 = false;
              }
              if (this.formdata.first_name && this.formdata.first_name != "") {
                this.show6 = false;
              }
              if (this.formdata.last_name && this.formdata.last_name != "") {
                this.show7 = false;
              }
              if (this.formdata.email && this.formdata.email != "") {
                this.show8 = false;
              }

              helper.done();
            } else {
              if (r.errorcode == "K2013") {
                this.errormessage =
                  r.msg[helper.getMappingLocale(this.$i18n.locale)];
                this.backtohome = true;
                $("#ReminderBox").modal("show");
              } else {
                this.errormessage =
                  this.$t("Something went wrong") +
                  " " +
                  r.msg[helper.getMappingLocale(this.$i18n.locale)] +
                  "(" +
                  r.errorcode +
                  ")";
                $("#ReminderBox").modal("show");
              }
              helper.done();
            }
          },
          function (r) {
            console.log(r);
            helper.done();
          },
          false,
          null
        );
      }
    }
  },
  updated() {
    if (this.action == 0) {
      this.heading = this.$t(
        "Register as a KLUB 11 Membership with K Dollar Program"
      );
      this.content = this.$t(
        "Become a KLUB 11 member today to enjoy exclusive privileges"
      );
      this.loading = this.$t("Continue");
    } else if (this.action == 1) {
      this.heading = this.$t("Register K Dollar Program Account");
      this.content = this.$t(
        "Please note that your existing KLUB points will be converted as K points after binding with your registered KDP Account"
      );
      this.loading = this.$t("Register and bind account");
    } else if (this.action == 2) {
      this.heading = this.$t(
        "Register as a KLUB 11 Member and bind with K Dollar Program"
      );
      this.content = this.$t(
        "Any updated you would like to make form details you provided in KDP"
      );
      this.loading = this.$t("I agree to bind");
    }
    let t1 = 0;
    let t2 = 0;

    let findText = this.$t("Program Terms and Conditions");
    var re = new RegExp(findText, "g");
    let findText2 = this.$t("Personal Information Collection Statement");
    var re2 = new RegExp(findText2, "g");
    var KDPpoc = "https://hk.krewards.com/zh-hk/program-terms-and-conditions/"
    var KDPics ="https://hk.krewards.com/zh-hk/personal-information-collection-statement/"
    if (this.$i18n.locale == "en") {
      KDPpoc = KDPpoc.replace("zh-hk","")
      KDPics = KDPics.replace("zh-hk","")
    } else if (this.$i18n.locale == "zh_CN") {
      KDPpoc = KDPpoc.replace("zh-hk","zh-cn")
      KDPics = KDPics.replace("zh-hk","zh-cn")
    }
    // this.linktext = this.$t("I have read, understood and agrees to")
    //   .replace(
    //     this.$t("Program Terms and Conditions"),
    //       //      https://web-hk-uat.krewards.com/terms-of-use/
    //       //      https://web-hk-uat.krewards.com/zh-hk/terms-of-use/
    //       //      https://web-hk-uat.krewards.com/zh-cn/terms-of-use/
    //       `<a href="${KDPpoc}" target="_blank">` +
    //       this.$t("Program Terms and Conditions") +
    //       "</a>"
    //   )
    //   .replace(re, (match) =>
    //     ++t1 === 2
    //       ? '<a href="https://klub-11.com/program-terms-and-conditions/" target="_blank">' +
    //         this.$t("Program Terms and Conditions") +
    //         "</a>"
    //       : match
    //   )
    //   .replace(
    //     this.$t("Personal Information Collection Statement"),
    //       //        https://web-hk-uat.krewards.com/privacy-policy/
    //       //        https://web-hk-uat.krewards.com/zh-hk/privacy-policy/
    //       //        https://web-hk-uat.krewards.com/zh-cn/privacy-policy/
    //       `<a href="${KDPics}" target="_blank">` +
    //       this.$t("Personal Information Collection Statement") +
    //       "</a>"
    //   )
    //   .replace(re2, (match) =>
    //     ++t2 === 2
    //       ? '<a href="https://kka.k11.com/en/personal-information-collection-statement/" target="_blank">' +
    //         this.$t("Personal Information Collection Statement") +
    //         "</a>"
    //       : match
    //   );
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
    ...mapGetters(['getPipl','getQs','isWechat']),
    ...mapGetters(['getAppLanguage']),
    ...mapGetters(['isSubmittable']),
    loader() {
        switch (this.getAppLanguage) {
            case "zh_HK":
                return () => import(`../components/pipl-k11-minor-pipl-tc.vue`);
            case "zh_CN":
                return () => import(`../components/pipl-k11-minor-pipl-sc.vue`);
            case "en":
            default:
                return () => import(`../components/pipl-k11-minor-pipl-en.vue`);
          }
    },
  },
  mounted() {
    this.retrieveWechatRelatedParams()
    this.setK11VipCode(this.partner_member_number)
    this.loader().then((compo) => {
        this.component = compo
    })
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapMutations(['setPIPL', 'setCustomPIPL', 'setData', 'setIsWechat', 'setWeChatQueryStringRelatedFields', 'setK11VipCode']),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    datecheck() {
      if ($(this.$refs.birth).val() != "") {
        $(this.$refs.birtherror)[0].innerText = "";
        return true;
      } else {
        $(this.$refs.birtherror)[0].innerText = this.$t("Date is invalid");
        return false;
      }
    },
    formDataCheck(email) {
        console.log(this.formdata.first_name != "" || $(this.$refs.first_name).val() != "")
        console.log(this.formdata.last_name != "" || $(this.$refs.last_name).val() != "")
        if ((this.formdata.first_name != "" || $(this.$refs.first_name).val() != "") &&
            (this.formdata.last_name != "" || $(this.$refs.last_name).val() != "") &&
            email &&
            this.formdata.age_range &&
            this.formdata.language &&
            this.formdata.gender &&
            // this.formdata.birthdaydd &&
            this.formdata.birthdaymm &&
            this.formdata.age_range !== "") {
                return true
            }
            return false
    },
    check() {
      if (!this.$refs.emailerror) return true;
      let filter =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (filter.test(this.formdata.email)) {
        $(this.$refs.emailerror)[0].innerText = "";
        return true;
      } else {
        if (this.formdata.email !== undefined){
          $(this.$refs.emailerror)[0].innerText = this.$t("Invalid Mail");
        }
        return false;
      }
    },
    kgoFormDataCheck(email) {
      let kgoDataFilled = false
      if (
          (this.getPipl("PIPL_CONSENT_VERSION") === 'minor' || 'general') &&
          this.formDataCheck(email)
        ) {
            kgoDataFilled = true
        }
      return kgoDataFilled;
    },
    kkaIsSubmittable(check, email) {
        //trigger when it is KKA - isWechat === false
        let disabled = true
        console.log(this.action)
        console.log(this.formdata.first_name != "" || $(this.$refs.first_name).val() != "")
        console.log(this.formdata.last_name != "" || $(this.$refs.last_name).val() != "")
        console.log(email)
        console.log(check)
        console.log(this.formdata.age_range)
        console.log(this.formdata.language)
        console.log(this.formdata.gender)
        console.log(this.formdata.birthdaymm)
        console.log(this.formdata.age_range)

        if (this.action == 0) {
          disabled =
                  !((this.formdata.first_name != "" || $(this.$refs.first_name).val() != "") &&
                  (this.formdata.last_name != "" || $(this.$refs.last_name).val() != "") &&
                  email &&
                  check &&
                  this.formdata.age_range &&
                  this.formdata.language &&
                  this.formdata.gender &&
                  // this.formdata.birthdaydd &&
                  this.formdata.birthdaymm &&
                  this.formdata.age_range !== ""
                  )
        } else if (this.action == 1) {
            disabled =
                  !((this.formdata.first_name != "" || $(this.$refs.first_name).val() != "") &&
                  (this.formdata.last_name != "" || $(this.$refs.last_name).val() != "") &&
                  email &&
                  check &&
                  this.formdata.age_range &&
                  this.formdata.language &&
                  this.formdata.gender &&
                  // this.formdata.birthdaydd &&
                  this.formdata.birthdaymm &&
                  this.formdata.age_range !== ""
                  )
        } else if(this.action == 2) {
          disabled =
                  !((this.formdata.first_name != "" || $(this.$refs.first_name).val() != "") &&
                  (this.formdata.last_name != "" || $(this.$refs.last_name).val() != "") &&
                  email &&
                  check &&
                  this.formdata.age_range &&
                  this.formdata.language &&
                  this.formdata.gender &&
                  // this.formdata.birthdaydd &&
                  this.formdata.birthdaymm &&
                  this.formdata.age_range !== ""
                  )
        }
        return disabled
    },
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
      if (this.backtohome) {
        window.sessionStorage.setItem("callbackurl", this.callbackurl);
        window.location.href = "./#/";
      }
    },
    retrieveWechatRelatedParams(){
      const isWechat = localStorage.getItem("isWechat") === "true"
      this.setIsWechat(isWechat)
      if (isWechat){
        //remove disable in submit button once it's from WeChat
        //this.disabled = false
        this.setCustomPIPL(JSON.parse(localStorage.getItem("pipl")))
        const keys = [
          'unionId', 'k11_optin', 'k11_aff_optin', 'kdp_optin', 'kdp_aff_optin', 'openId', 'openType'
        ]
        const params = {}
        Promise.all(keys.map(key => {
          params[key] = localStorage.getItem(key)
        }))
        this.setWeChatQueryStringRelatedFields(params)
      }
    },
    async btnSubmit(pipl) {
      console.log('submit')
      helper.loading();
      let vm = this;
      $(vm.$refs.load).css("z-index", "2147483647");
      vm.spinner = true;
      var first_name = this.formdata.first_name;
      var last_name = this.formdata.last_name;
      var email = this.formdata.email;
      var gender = this.formdata.gender;
      var birthdaydd = this.formdata.birthdaydd;
      var birthdaymm = this.formdata.birthdaymm;
      var language = this.formdata.language;
      var age = this.formdata.age_range;
      // var check1 = $(this.$refs.agreement_1).is(":checked");
      var check3 = $(this.$refs.agreement_3).is(":checked");
      var check4 = $(this.$refs.agreement_4).is(":checked");
      var check5 = $(this.$refs.agreement_5).is(":checked");
      var check6 = $(this.$refs.agreement_6).is(":checked");
      // var check7 = $(this.$refs.agreement_7).is(":checked");
      // var check8 = $(this.$refs.agreement_8).is(":checked");

      // var isagree_kdp_tnc = 0;
      var isagree_klub11_opt_in = 1;
      var marketing_opt_in = 0;
      var isagree_klub11_affiliates_opt_in = 0;
      var isagree_kdp_affiliates_opt_in = 0;

      // if (check1) {
      //   isagree_kdp_tnc = 1;
      // }
      if (check3) {
        isagree_klub11_opt_in = 0;
      }
      if (check4) {
        marketing_opt_in = 1;
      }
      if (check5) {
        isagree_klub11_affiliates_opt_in = 1;
      }
      if (check6) {
        isagree_kdp_affiliates_opt_in = 1;
      }
      // if (check7) {
      //   isagree_klub11_opt_in = 0;
      //   marketing_opt_in = 1;
      // }
      // if (check8) {
      //   isagree_klub11_affiliates_opt_in = 1;
      //   isagree_kdp_affiliates_opt_in = 1;
      // }
      //isagree_klub11_opt_in = k11_optin
      //isagree_klub11_affiliates_opt_in = k11_aff_optin
      //marketing_opt_in = kdp_optin
      //isagree_kdp_affiliates_opt_in = kdp_aff_optin

      if (!pipl) {
        if (this.isWechat){
          if (this.formdata.age_range == 1) {
            this.needConsent = true;
            this.setPIPL("reset_values")
            this.showModal = this.needConsent;
            vm.spinner = false;
            $(vm.$refs.load).css("z-index", 0);
            helper.done();
            return
          }else{
            this.retrieveWechatRelatedParams()
          }
        } else {
          try {
              const response = await fetch("/migrationhub/checkPIPL", {
                  method: "POST", headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                  }, body: JSON.stringify({
                      "countryCode": this.country_code.replace(/^\+/, ''),
                      "email": email
                  })
              });
              const {needConsent} = await response.json();
              if (needConsent){
                  this.needConsent = needConsent;
                  this.showModal = this.needConsent;
                  vm.spinner = false;
                  $(vm.$refs.load).css("z-index", 0);
                  helper.done();
                  return
              }
          } catch (e) {
              console.log('pipl call fail', e)
              vm.spinner = false;
              $(vm.$refs.load).css("z-index", 0);
              helper.done();
              return
          }
        }
      } else {
          this.showModal = false
      }
      try {
        var phone = this.phone;
        var country_code = this.country_code;
        var kdp_creation_ind = 0;
        var k11_creation_ind = 0;
        if (this.iskdp == 0) {
          kdp_creation_ind = 1;
        }
        if (this.isk11 == 0) {
          k11_creation_ind = 1;
        }
        const piplFields = this.getPipl('pipl')
        console.log("PIPL Fields when Submit", piplFields)
        let data = {
          parameters: {
            kdp_member_number: vm.kdp_member_number,
            k11_member_number: vm.partner_member_number,
            mobile_phone: {
                country_code: country_code,
                number: phone,
            },
            email: email,
            name: {
              en: {
                  first_name: first_name,
                  last_name: last_name,
              },
              // sc: {
              //   first_name: first_name,
              //   last_name: last_name,
              // },
            },
            issuestore: "HK04",
            gender: gender,
            date_of_birth: {
                month: birthdaymm,
                day: birthdaydd,
            },
            id_card_info: {},
            locale: language,
            addresses: [],
            kdp_creation_ind: kdp_creation_ind,
            k11_creation_ind: k11_creation_ind,
            age_range: age,
            // isagree_kdp_tnc: this.isWechat ? 1 : isagree_kdp_tnc,
            isagree_klub11_opt_in: this.isWechat && this.$store.state.k11_optin == '1' ? 0 : isagree_klub11_opt_in,
            marketing_opt_in: this.isWechat && this.$store.state.kdp_optin == '1' ? 1 : marketing_opt_in,
            isagree_klub11_affiliates_opt_in:
            this.isWechat && this.$store.state.k11_aff_optin == '1' ? 1 : isagree_klub11_affiliates_opt_in,
            isagree_kdp_affiliates_opt_in: this.isWechat && this.$store.state.kdp_aff_optin == '1' ? 1 : isagree_kdp_affiliates_opt_in,
            union_id: this.$store.state.unionId,
            openId: this.$store.state.openId,
            openType: this.$store.state.openType,
            ...this.getPipl('pipl'),
          },
          phone: vm.phone,
          country_code: vm.country_code,
          SESSION: vm.session,
        };
        api.request(
          this,
          "post",
          "/migrationhub/member/registration",
          {...data},
          function (r) {
            if (r.success) {
              helper.done();

              let check_k11vipcode = r.data.k11_profile.vipcode.substring(0, 2);

              if (check_k11vipcode != "01") {
                window.sessionStorage.setItem("isCN", true);
              } else {
                window.sessionStorage.setItem("isCN", false);
              }

              if (vm.action == 0) {
                window.sessionStorage.setItem("email", email);
                vm.changeurl();
                window.location.href = "./#/success";
              } else if (vm.action == 1) {
                window.sessionStorage.setItem("email", vm.formdata.email);
                window.sessionStorage.setItem("curbonus", vm.curbonus);
                vm.changeurl();
                window.location.href = "./#/kdpsuccess";
              } else if (vm.action == 2) {
                window.sessionStorage.setItem("email", email);
                vm.changeurl();
                window.location.href = "./#/success";
              }
            } else {
              vm.spinner = false;
              if (vm.action == 0) {
                vm.loading = vm.$t("Continue");
              } else if (vm.action == 1) {
                vm.loading = vm.$t("Register and bind account");
              } else if (vm.action == 2) {
                vm.loading = vm.$t("I agree to bind");
              }
              $(vm.$refs.load).css("z-index", 0);
              if (r.errorcode == "K2013") {
                vm.errormessage =
                  r.msg[helper.getMappingLocale(vm.$i18n.locale)];
                vm.backtohome = true;
                $("#ReminderBox").modal("show");
              } else {
                vm.errormessage =
                  vm.$t("Something went wrong") +
                  " " +
                  r.msg[helper.getMappingLocale(vm.$i18n.locale)] +
                  "(" +
                  r.errorcode +
                  ")";
                $("#ReminderBox").modal("show");
              }
              helper.done();
            }
          },
          function (r) {
            // console.log(r);
            vm.spinner = false;
            vm.errormessage = vm.$t("Network error");
            $("#ReminderBox").modal("show");
            $(vm.$refs.load).css("z-index", "0");
            if (vm.action == 0) {
              vm.loading = vm.$t("Continue");
            } else if (vm.action == 1) {
              vm.loading = vm.$t("Register and bind account");
            } else if (vm.action == 2) {
              vm.loading = vm.$t("I agree to bind");
            }
            helper.done();
            $(vm.$refs.load).css("z-index", "0");
            helper.done();
          },
          false,
          null
        );
      } catch (error) {
        vm.spinner = false;
        vm.errormessage = vm.$t("Network error");
        $("#ReminderBox").modal("show");
        $(vm.$refs.load).css("z-index", "0");
        if (vm.action == 0) {
          vm.loading = vm.$t("Continue");
        } else if (vm.action == 1) {
          vm.loading = vm.$t("Register and bind account");
        } else if (vm.action == 2) {
          vm.loading = vm.$t("I agree to bind");
        }
        helper.done();
      }
      // }
    },
  },
};
</script>
